<template>
  <div>
    <p>
      The Sun zenith angle refers to the angle between the local normal of the
      Earth surface and the solar rays incidence direction.
      <br />
      Its maximum value defines an enlightenment condition considered during the
      simulation. Any point for which the Sun zenith angle is greater than this
      value is considered as not seen by the payload due to the poor
      enlightenment.
      <br />
      <v-img
        contain
        :src="require('../../../assets/images/tooltip-sun-zenith-angle.png')"
        aspect-ratio="1.6"
      />
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipSunZenithAngle'
}
</script>
